export function commissionTypeOptions($t) {
  return [
    { value: 'percent', text: $t('frontend_product_step9_percentage') },
    { value: 'fixed', text: $t('frontend_product_step9_fixed_amount') },
  ];
}

export function primaryCommission(pricePoint, commissionTier) {
  return pricePoint.is_trial == 1 ? commissionTier.trial_commission : commissionTier.sales_commission;
}

export function formatCommission(value, type) {
  const amount = value === null || value === undefined || value === '' ? 0 : value;
  return type === 'fixed' ? `$${amount}` : `${amount}%`;
}

export function commissionSummary(pricePoint, commissionTier) {
  const primary = primaryCommission(pricePoint, commissionTier) || {};
  const parts = [
    `Tier 1 ${formatCommission(primary.commission, primary.commission_type)}`,
    `Tier 2 ${formatCommission(primary.jv_broker_commission, primary.jv_broker_commission_type)}`,
  ];
  const rows = (commissionTier.rebill_commissions || []).length;
  if (pricePoint.type != 1 && rows > 1) {
    parts.push(`${rows}-step payment schedule`);
  }
  return parts.join(' · ');
}

function previousPaymentCount(rebillCommissions, index) {
  return rebillCommissions.slice(0, index).reduce((total, item) => total + (parseInt(item.no_of_payments, 10) || 0), 0);
}

export function recurringRangeLabel(rebillCommissions, index) {
  const start = previousPaymentCount(rebillCommissions, index) + 1;
  const count = parseInt(rebillCommissions[index].no_of_payments, 10);
  if (!count) {
    return `Payment ${start}+`;
  }
  const end = start + count - 1;
  return start === end ? `Payment ${start}` : `Payments ${start}-${end}`;
}

export function recurringRangeDescription(rebillCommissions, index) {
  const count = parseInt(rebillCommissions[index].no_of_payments, 10);
  if (!count) {
    return 'All remaining payments';
  }
  return `Next ${count} payment${count === 1 ? '' : 's'}`;
}

export function newRebillCommission(commission) {
  return {
    commission,
    no_of_payments: null,
    commission_type: 'percent',
    jv_broker_commission: 0,
    jv_broker_commission_type: 'percent',
  };
}
